import { useMutation } from '@tanstack/react-query';
import { message } from 'antd';
import { uploadFile, getFile, downloadZipFile as apiDownloadZipFile } from '../apis';
export const useFileHandler = () => {
    const [messageApi] = message.useMessage();
    const uploadFileMutation = useMutation({
        mutationFn: (body) => uploadFile(body)
    });
    const getFileMutation = useMutation({
        mutationFn: (path) => getFile(path)
    });
    const UploadFileServer = async (uploadFiles, folderName) => {
        if (!uploadFiles?.length)
            return null;
        const formData = new FormData();
        formData.append('folderName', folderName);
        uploadFiles.forEach((uploadFile) => {
            if (uploadFile?.originFileObj) {
                const file = uploadFile.originFileObj;
                formData.append('files', file, file.name);
            }
        });
        try {
            return await uploadFileMutation.mutateAsync(formData);
        }
        catch {
            messageApi.open({
                type: 'error',
                content: 'Tải file lên không thành công.'
            });
            return null;
        }
    };
    const handleGetFile = (path, originalName) => {
        const extension = path.split('.').pop()?.toLowerCase();
        const mimeTypes = {
            pdf: 'application/pdf',
            doc: 'application/msword',
            docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            xls: 'application/vnd.ms-excel',
            xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            png: 'image/png'
        };
        const mimeType = mimeTypes[extension || ''] || 'application/octet-stream';
        getFileMutation.mutate(path, {
            onSuccess: (response) => {
                const blob = new Blob([response.data], { type: mimeType });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', originalName);
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
            }
        });
    };
    const handleDownloadZip = async (fileName, fileUrls) => {
        try {
            await apiDownloadZipFile(fileName, fileUrls);
            messageApi.open({ type: 'success', content: 'Đã tải về zip thành công!' });
        }
        catch (error) {
            messageApi.open({ type: 'error', content: error?.message || 'Tải zip thất bại!' });
        }
    };
    return {
        UploadFileServer,
        handleGetFile,
        handleDownloadZip,
        isUploading: uploadFileMutation.isLoading,
        isGettingFile: getFileMutation.isLoading
    };
};
